import * as React from 'react'
import { useRouter } from 'next/router'
import { NextSeo, BreadcrumbJsonLd } from 'next-seo'

import { toAbsoluteUrl } from 'utils/routes'

interface SEOProps {
    title: string
    description?: string
    breadcrumbs?: Breadcrumb[]
}

export type Breadcrumb = {
    name: string
    path: string
}

export default function SEO({ title, description, breadcrumbs }: SEOProps) {
    const router = useRouter()

    return (
        <>
            <NextSeo
                title={title}
                titleTemplate={'%s | Devv'}
                description={description}
                canonical={`${toAbsoluteUrl(router.asPath)}`}
            />
            {breadcrumbs && (
                <BreadcrumbJsonLd
                    itemListElements={breadcrumbs.map((e, index) => ({
                        position: index + 1,
                        name: e.name,
                        item: `${toAbsoluteUrl(e.path)}`,
                    }))}
                />
            )}
        </>
    )
}
